'use strict';

module.exports = {
	GOOGLE: 'google',
	FACEBOOK: 'facebook',
	BLACK_ROCKET: 'blackRocket',
	CAMP_LMS: 'campLms',
	STUB: 'stub'
};
